// extracted by mini-css-extract-plugin
module.exports = {"error":"ErrorPage_error__7Kof4"};